import { render, staticRenderFns } from "./existenciaArmazem.vue?vue&type=template&id=37867204&scoped=true&"
import script from "./existenciaArmazem.vue?vue&type=script&lang=js&"
export * from "./existenciaArmazem.vue?vue&type=script&lang=js&"
import style0 from "./existenciaArmazem.vue?vue&type=style&index=0&id=37867204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37867204",
  null
  
)

export default component.exports